import { render } from "./narvar_ingles.vue?vue&type=template&id=31333bdc&scoped=true"
import script from "./narvar_ingles.vue?vue&type=script&lang=js"
export * from "./narvar_ingles.vue?vue&type=script&lang=js"

import "./narvar_ingles.vue?vue&type=style&index=0&id=31333bdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31333bdc"]])

export default __exports__